export const TypeUtilisateurEnums = {
    ADMINISTRATEUR: "ADMINISTRATEUR",
	CHEF_PARC: "CHEF_PARC",
    RESPONSABLE_STRUCTURE: "RESPONSABLE_STRUCTURE",
	SIMPLE_UTILISATEUR: "SIMPLE_UTILISATEUR",
	TEST: "TEST"
}